import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useContent } from "../lib/content";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/guides", label: "Rituals & Guides" },
  { to: "/visit", label: "Visit Us" },
];

export default function Header() {
  const { count, setOpen } = useCart();
  const { content: c } = useContent();
  const [mobile, setMobile] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-[rgba(253,251,247,0.85)] border-b border-[var(--srishti-border)]"
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
        <button
          className="md:hidden"
          onClick={() => setMobile((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {mobile ? <X size={22} /> : <Menu size={22} />}
        </button>

        <Link
          to="/"
          className="flex flex-col items-center md:items-start"
          data-testid="brand-logo"
        >
          <span className="font-serif-display text-2xl md:text-3xl text-[var(--srishti-maroon)] leading-none">
            {c.brand_name}
          </span>
          <span className="eyebrow mt-0.5 text-[10px]">
            {c.brand_tagline}
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-sm tracking-wide hover:text-[var(--srishti-maroon)] transition-colors ${
                  isActive
                    ? "text-[var(--srishti-maroon)] font-semibold"
                    : "text-[var(--srishti-text-secondary)]"
                }`
              }
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          onClick={() => setOpen(true)}
          className="relative p-2"
          aria-label="Open cart"
          data-testid="open-cart-button"
        >
          <ShoppingBag size={22} />
          {count > 0 && (
            <span
              className="absolute -top-0 -right-0 bg-[var(--srishti-maroon)] text-[10px] text-white w-5 h-5 flex items-center justify-center rounded-full"
              data-testid="cart-count-badge"
            >
              {count}
            </span>
          )}
        </button>
      </div>

      {mobile && (
        <div
          className="md:hidden border-t border-[var(--srishti-border)] bg-[var(--srishti-bg)]"
          data-testid="mobile-menu"
        >
          <div className="flex flex-col px-6 py-4 gap-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setMobile(false)}
                className="text-sm text-[var(--srishti-text)]"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
